import { CanDeactivate } from "@angular/router";
import { BaseUpdateComponent } from "../base-classes/base-update-component";
import { Injectable } from "@angular/core";
import { BaseTabsUpdateComponent } from "../base-classes/base-tabs-update-component";
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from "./modal.service";
// import { ConfirmationDialogButtons } from "../../public_api";
import { ConfirmationDialogButtons } from '../base-components/confirmation-dialog/confirmation-dialog-buttons';

@Injectable({
    providedIn: 'root'
})
export class CanDeactivateGuard implements CanDeactivate<BaseUpdateComponent<any>>{
    constructor(protected translateService: TranslateService,
                protected modalService: ModalService){

    }

    // Postaviti custom dijalog za ovu metodu i ispraviti metodu da kada se prelazi na drugu masku da pre prelaska izbaci dijalog 
    // i da se namesti da ukoliko se klikne taster Da da predje na novu stranicu  ukoliko se stisne Ne da ostane na prvobitnoj.

    async canDeactivate(component: BaseUpdateComponent<any>): Promise<boolean>{
        let mainBaseUpdateComponent: BaseUpdateComponent<any>;
        let detailBaseUpdateComponent: BaseUpdateComponent<any>;
        if(component['baseTabsUpdate'])   
            mainBaseUpdateComponent = component['baseTabsUpdate']['baseUpdateComponent'];
        if(component['baseTabsUpdate'] && 
           component['baseTabsUpdate']['baseUpdateComponent'] && 
           component['baseTabsUpdate']['baseUpdateComponent']['baseInlineContainer'] && 
           component['baseTabsUpdate']['baseUpdateComponent']['baseInlineContainer']['baseInlineUpdateComponent'])
            detailBaseUpdateComponent = component['baseTabsUpdate']['baseUpdateComponent']['baseInlineContainer']['baseInlineUpdateComponent']['baseUpdateComponent'];
            
         
        if (!mainBaseUpdateComponent.canDeactivate() || (detailBaseUpdateComponent && !detailBaseUpdateComponent.canDeactivate())) {
            const modalRef = this.modalService.ShowConfirmationDialog(
                "Obaveštenje",
                "Postoje promene u tekućim podacima. Akcijom koju ste pokrenuli promene neće biti sačuvane.",
                "question",
                ConfirmationDialogButtons.ConfirmCancel
            );
    
            try {
                const result = await modalRef.result;
                return result === true;
            } catch (error) {
                return false;
            }
        }
    
        return true; 
    }
}